import React from "react";
import axios from "axios";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { useSelector } from "react-redux/es/hooks/useSelector";
import { useMediaQuery } from "react-responsive";

import {
  Box,
  Button,
  Menu,
  MenuItem,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
  TextField,
  Divider,
} from "@mui/material";

import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";

import logo from "../../assets/logoNuevo.png";
import "./NavBarNew.Module.css";
import { isAuthenticated } from "../../utils/auth/auth";

export default function NavBarNewInfo() {
  const isMobileScreen = useMediaQuery({ maxWidth: 700 });
  const user = useSelector((state) => state.user.userInfo);

  const BACK_URL = process.env.REACT_APP_BACK_URL;
  const SETTINGS_KEY = "bannerTextsInfo";

  const isSuperAdmin = user?.role === "SUPERADMIN_ROLE";
  const isAdmin = user?.role === "ADMIN_ROLE" || user?.role === "SUPERADMIN_ROLE";
  const logged = isAuthenticated() && !!user?.role;

  const token = localStorage.getItem("Token");
  const config = {
    headers: {
      xtoken: token,
    },
  };

  /* =======================
     Banner state + fetch
  ======================= */
  const [bannerTexts, setBannerTexts] = React.useState(["CARGANDO…"]);
  const [openBannerDialog, setOpenBannerDialog] = React.useState(false);
  const [draftTexts, setDraftTexts] = React.useState([]);
  const [savingBanner, setSavingBanner] = React.useState(false);

  const fetchBanner = React.useCallback(async () => {
    try {
      const { data } = await axios.get(
        `${BACK_URL}/api/site-settings/${SETTINGS_KEY}`
      );
      if (Array.isArray(data?.value) && data.value.length) {
        setBannerTexts(data.value);
      } else {
        setBannerTexts([
          "6 CUOTAS SIN INTERÉS BANCO MACRO",
          "ENVÍOS GRATIS A PARTIR DE $99.999",
        ]);
      }
    } catch {
      setBannerTexts([
        "6 CUOTAS SIN INTERÉS BANCO MACRO",
        "ENVÍOS GRATIS A PARTIR DE $99.999",
      ]);
    }
  }, [BACK_URL]);

  React.useEffect(() => {
    fetchBanner();
  }, [fetchBanner]);

  /* =======================
     Banner editor handlers
  ======================= */
  const openEditor = () => {
    setDraftTexts(bannerTexts.map((t) => String(t)));
    setOpenBannerDialog(true);
  };

  const updateDraft = (idx, value) => {
    setDraftTexts((prev) => prev.map((t, i) => (i === idx ? value : t)));
  };

  const addDraft = () => setDraftTexts((prev) => [...prev, ""]);
  const removeDraft = (idx) =>
    setDraftTexts((prev) => prev.filter((_, i) => i !== idx));

  const saveBanner = async () => {
    const cleaned = draftTexts.map((t) => t.trim()).filter(Boolean);
    if (!cleaned.length) return alert("Debe haber al menos un texto.");

    try {
      setSavingBanner(true);
      await axios.put(
        `${BACK_URL}/api/site-settings/${SETTINGS_KEY}`,
        { value: cleaned },
        config
      );
      setBannerTexts(cleaned);
      setOpenBannerDialog(false);
    } catch {
      alert("No se pudo guardar el banner.");
    } finally {
      setSavingBanner(false);
    }
  };

  /* =======================
     Banner carousel config
  ======================= */
  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  /* =======================
     User menu
  ======================= */
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openUserMenu = Boolean(anchorEl);

  return (
    <Box sx={{ position: "absolute", width: "100%", zIndex: 2000000 }}>
      {/* ================= Banner ================= */}
      <Box sx={{ position: "relative" }}>
        {isSuperAdmin && (
          <IconButton
            onClick={openEditor}
            size="small"
            sx={{
              position: "absolute",
              right: 10,
              top: 6,
              zIndex: 10,
              background: "rgba(255,255,255,0.2)",
            }}
          >
            <EditIcon sx={{ color: "#fff" }} fontSize="small" />
          </IconButton>
        )}

        <Carousel
          responsive={responsive}
          infinite
          autoPlay
          autoPlaySpeed={3000}
          showDots={false}
          removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}
        >
          {bannerTexts.map((text, i) => (
            <Box
              key={i}
              sx={{
                height: "45px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#23563F",
                color: "#fff",
                fontWeight: 700,
                fontFamily: "Poppins",
                fontSize: isMobileScreen ? "12px" : "16px",
              }}
            >
              {text}
            </Box>
          ))}
        </Carousel>
      </Box>

      {/* ================= Navbar ================= */}
      <div className="navbar navbar-expand-md border-bottom divNavBar">
        <Navbar expand="lg" className="container-fluid navbaaar">
          {/* Logo */}
          <Navbar.Brand as={Link} to="/" className="logo">
            <img src={logo} alt="Logo" />
          </Navbar.Brand>

          {isMobileScreen && <Navbar.Toggle />}

          <Navbar.Collapse>
            <Nav className="ms-auto align-items-lg-center gap-4">
              <NavLink to="/" className="linkNavBarMarket">Inicio</NavLink>

              <NavDropdown title="Beauti Salon" className="linkNavBarMarket">
                <NavDropdown.Item as={Link} to="/cartilla/nails">Nails</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/cartilla/minibeautiqueras">Mini beautiqueras</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/cartilla/beautibox">Beautibox</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/cartilla/w&e">Events | Workshops</NavDropdown.Item>
              </NavDropdown>

         <a
  href="https://labeautiqueriamarket.mitiendanube.com/"
  target="_blank"
  rel="noopener noreferrer"
  className="linkNavBarMarket"
>
  Tienda Online
</a>
              <NavLink to="/alianzas" className="linkNavBarMarket">Beauti Comunidad</NavLink>
              <NavLink to="/contacto" className="linkNavBarMarket">Contacto</NavLink>

             {!logged ? (
  <NavLink
    to="/iniciarSesion"
    className="linkNavBarMarket linkLogin"
  >
    Iniciar Sesión
  </NavLink>
) : (

                <>
                  <Button
                    className="dropdowncitoB"
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                  >
                    <PersonOutlineIcon />
                  </Button>

                  <Menu anchorEl={anchorEl} open={openUserMenu} onClose={() => setAnchorEl(null)}>
                    <MenuItem component={Link} to="/perfil">Mi perfil</MenuItem>
                    {isAdmin && <MenuItem component={Link} to="/dashboard">Dashboard</MenuItem>}
                  </Menu>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>

      {/* ================= Dialog editor ================= */}
      <Dialog open={openBannerDialog} onClose={() => setOpenBannerDialog(false)} fullWidth maxWidth="sm">
        <DialogContent>
          <Typography fontWeight={700}>Editar textos del banner</Typography>
          <Divider sx={{ my: 2 }} />

          {draftTexts.map((t, i) => (
            <Box key={i} sx={{ display: "flex", gap: 1, mb: 1 }}>
              <TextField
                value={t}
                fullWidth
                size="small"
                onChange={(e) => updateDraft(i, e.target.value)}
              />
              <IconButton onClick={() => removeDraft(i)}>
                <DeleteOutlineIcon />
              </IconButton>
            </Box>
          ))}

          <Button startIcon={<AddIcon />} onClick={addDraft}>
            Agregar texto
          </Button>

          <Divider sx={{ my: 2 }} />

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button onClick={() => setOpenBannerDialog(false)}>Cancelar</Button>
            <Button
              variant="contained"
              startIcon={<SaveIcon />}
              onClick={saveBanner}
              disabled={savingBanner}
            >
              Guardar
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
